import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  PageEvent,
  MatDialog,
  MatPaginator,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material";
import { Router } from "@angular/router";
import { User, Users } from "src/_models/users";
import { portalUsers } from "src/_models/user";
import { AppService } from "src/_services/app.service";
import { AuthenticationService } from "src/_services/authentication.service";
import { ChangePasswordModalComponent, CreateUsersComponent, EditUserComponent } from "../index";
import { B2BUserMangUsers, roleTypeOperator, roleTypeSap } from "src/_constants/roleType";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TwoFaQrModalComponent } from "./twofa-qr-modal.component";
import { AssignUserLimitComponent } from "../assign-user-limit/assign-user-limit.component";

@Component({
  selector: "app-user-management",
  templateUrl: "./user-management.component.html",
  styleUrls: ["./user-management.component.scss"],
})
export class UserManagementComponent implements OnInit {
  usersDisplayedColumns: string[] = ["UserId", "UserName", "Balance", "Status", "Action"];
  portalUsersColumn: string[] = [
    "UserId",
    "UserName",
    "UserKey",
    "OperatorId",
    "Status",
    "Action",
  ];

  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  users = new MatTableDataSource<User>();
  portalUsersData = new MatTableDataSource<portalUsers>();
  count: number = 0;
  searchUserName: string = "";
  showOperatorData: boolean = true;
  showSAPData: boolean = true;
  portalList:any;
  searchKey = "";
  ForGA = ["GroupAdmin"].includes(this.userRole.role) || B2BUserMangUsers.includes(this.userRole.userId);
  page = 1;
  pageSize = 10;
  orgPageSize = 10;
  length = 0;
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  dropdownSettings: any = {};
  selectedStatus = new FormControl([]);
  statuses= ["ACTIVE","BLOCKED","BOT"]

  constructor(
    public dialog: MatDialog,
    private appService: AppService,
    private router: Router,
    private authService: AuthenticationService
  ) {
    this.portalUsersColumn =
      !this.ForGA
        ? this.portalUsersColumn
        : [
          "UserId",
          "UserName",
          "UserKey",
          "OperatorId",
          ];
    }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: false,
    };
    this.showOperatorData = roleTypeOperator.includes(this.userRole.role);
    this.showSAPData = roleTypeSap.includes(this.userRole.role) || this.ForGA;
    this.getServerData();
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  getServerData(event?: PageEvent) {
    const pagination = {
      Number: 0,
      Page: 0,
    };

    if (event && event.pageIndex) {
      pagination.Page =
        event.pageIndex > event.previousPageIndex
          ? event.pageIndex + 1
          : event.pageIndex - 1;
    }
    let status = this.selectedStatus.value.length != 0 ? this.selectedStatus.value[0] :"";
    this.appService
      .getUsers(this.page, this.orgPageSize,status, this.searchUserName)
      .subscribe((res) => {
        if (res.status === "RS_OK") {
          if (this.showSAPData) {
            // this.portalUsersData.data = res.portalUsers;
            this.portalUsersData = new MatTableDataSource<any>(res.portalUsers);
            this.portalList = res.portalUsers
            this.portalUsersData.paginator = this.paginator;
          } else {
            // this.users.data = res.users;
            // this.count = res.count;
            this.users = new MatTableDataSource<any>(res.users);
            if (this.page == 1) {
              this.length = res.totalRecords
            }
          }
        } else {
          this.appService.openErrorBar(res.errorDescription);
          this.router.navigateByUrl("/login");
        }
      });
  }

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getServerData();
  }

  redirectAddUserPage = () => {
    this.dialog.open(CreateUsersComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: { },
    });
    // this.router.navigate(["/create-user"]);
  };

  goTo(link) { 
    let linkRoute =
      `/administration/users/` + link.OperatorId;
    this.router.navigate([linkRoute]);
  }

  searchUserId(event) {
    const value = event.target.value;
    this.portalUsersData.filter = value.trim().toLocaleLowerCase();
  }

  changePassword = (element) => {
    this.dialog.open(ChangeUserPasswordComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: { 
        OperatorId: element.OperatorId,
        UserId: element.UserId,
      },
    });
  };

  openTwoFaQr(element: any) {
    this.dialog.open(TwoFaQrModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: element,
    });
  }

  handleChange(e, user: User) {
    let operatorId = "";
    if (e.checked) {
      this.appService.unBlockUser(user.userId, operatorId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    } else {
      this.appService.blockUser(user.userId, operatorId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    }
  }
  assignLimit(user: User) {
    const dialogRef = this.dialog.open(AssignUserLimitComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      width: "460px",
      panelClass: "assign-limit-dialog-panel",
      data: {
        userId: user.userId,
        userName: user.userName,
        operatorId: this.userRole.operatorId,
        limitId: user.limitId,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getServerData();
      }
    });
  }

  handleChangeportalUsers(e, user: portalUsers) {
    user.Status = e.checked === false ? "INACTIVE" : "ACTIVE";

    let userKey = user.UserKey;
    if (this.showSAPData) {
      if (e.checked) {
        this.appService.unBlockPortalUser(userKey).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
      } else {
        this.appService.blockPortalUser(userKey).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
      }
    }
  }

  searchUser(event) {
    const value = event.target.value;
    this.searchUserName = value;
    this.getServerData();
    // this.users.filter = value.trim().toLocaleLowerCase();
  }

  editUser(element) {
    this.dialog.open(EditUserComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        operatorId: element.OperatorId,
        userId: element.UserId,
        operators: element.Operators ? element.Operators : null,
        role: element.Role,
        userName: element.UserName,
        invoice: element.Invoice,
        TwoFAEnabled: element.TwoFAEnabled,
       },
    });
    // this.router.navigate(["/edit-user"], {
    //   queryParams: {
    //     operatorId: element.OperatorId,
    //     userId: element.UserId,
    //     operators: element.Operators ? element.Operators : null,
    //     role: element.Role,
    //     userName: element.UserName,
    //   },
    // });
  }

  deleteModal(data) {
      const dialogRef = this.dialog.open(DeleteUserModalComponent, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          user_id : data.UserId
        },
      });
    dialogRef.afterClosed().subscribe(() => {
      this.getServerData();
    }); 
  }
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./delete-user.component.html",
  styleUrls: ["./user-management.component.scss"],
})
export class DeleteUserModalComponent {
  DATA;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private router: Router,
    public dialogRef : MatDialogRef<DeleteUserModalComponent>,
  ) {
    this.DATA = data;
  }

  ngOnInit() {}

  deleteUser() {
    console.log(this.DATA)
    this.appService.deleteUser(this.DATA.user_id).subscribe((res) => {
          if(res.status === "RS_OK"){
            this.appService.openSuccessBar(res.errorDescription)
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
          this.dialogRef.close();
        },
        (err) => {}
      );
  }
}


@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./change-user-password.component.html",
  styleUrls: ["./user-management.component.scss"],
})

export class ChangeUserPasswordComponent {
  Data;
  newPasswordForm : FormGroup
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private router: Router,
    public dialogRef : MatDialogRef<ChangeUserPasswordComponent>,
  ) {
    this.Data = data;
  }

  ngOnInit() {
    this.newPasswordForm = new FormGroup({
     UserId: new FormControl({ value: null, disabled: true }),
     OperatorId: new FormControl({ value: null, disabled: true }),
     Password: new FormControl(null, [Validators.required]),
  });
}

  changeUserPassword(){
    const request = {
      userId : this.Data.UserId,
      operatorId : this.Data.OperatorId,
      newPassword : this.newPasswordForm.value.Password
    };
    this.appService.resetUserPassword(request).subscribe((res) => {
      this.dialogRef.close();
        this.appService.openSuccessBar("User Password updated successfully.");
       // this.redirectPage();
    })
  }

}

